import React from 'react';
import { Modal, Button } from '../common';

export const SceneSelectorModal = ({
  isOpen,
  onClose,
  scenes = [],
  selectedSceneId,
  currentSceneId,
  onSelectScene,
  onCreateNew,
  isCreating = false,
}) => {
  // Determine which scene is selected for display
  const effectiveSelectedId = selectedSceneId || currentSceneId;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Select Scene"
      size="md"
    >
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          Choose a scene for the next round, or create a new one.
        </p>

        {/* Scene List */}
        <div className="space-y-2 max-h-80 overflow-y-auto">
          {scenes.map((scene) => {
            const sceneId = scene.id || scene._id;
            const isSelected = effectiveSelectedId === sceneId;
            return (
              <button
                key={sceneId}
                type="button"
                onClick={() => {
                  onSelectScene(sceneId);
                  onClose();
                }}
                className={`w-full p-4 rounded-lg border-2 text-left transition-all ${
                  isSelected
                    ? 'border-primary-500 bg-primary-50'
                    : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                }`}
              >
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-8 h-8 bg-gray-700 text-white rounded-full flex items-center justify-center text-sm font-bold">
                    {scene.number}
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-gray-900">
                      {scene.title || `Scene ${scene.number}`}
                    </p>
                    {scene.description && (
                      <p className="text-sm text-gray-600 mt-1 line-clamp-2">
                        {scene.description}
                      </p>
                    )}
                    <div className="flex items-center gap-3 mt-2 text-xs text-gray-500">
                      {scene.characterIds?.length > 0 && (
                        <span>{scene.characterIds.length} character{scene.characterIds.length !== 1 ? 's' : ''}</span>
                      )}
                      {scene.aspects?.length > 0 && (
                        <span>{scene.aspects.length} aspect{scene.aspects.length !== 1 ? 's' : ''}</span>
                      )}
                    </div>
                  </div>
                  {isSelected && (
                    <div className="flex-shrink-0 w-6 h-6 bg-primary-500 rounded-full flex items-center justify-center">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                  )}
                </div>
              </button>
            );
          })}
        </div>

        {/* Create New Scene */}
        <div className="border-t pt-4">
          <Button
            variant="secondary"
            className="w-full"
            onClick={() => {
              onCreateNew();
              onClose();
            }}
            loading={isCreating}
          >
            <span className="flex items-center justify-center gap-2">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              Create New Scene
            </span>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
